const toNumber = (value) => {
  if (value === undefined || value === null || value === "") return value;
  const num = Number(value);
  return Number.isNaN(num) ? value : num;
};

export const transformPayrollData = (payrollData) => {
  return payrollData.map((item) => {
    const isTotalRow = item?.isTotalRow === true;

    const grossDetails = Object.fromEntries(
      item?.totalGrossPayDetails?.map((d) => [d?.displayText, toNumber(d?.value)]) ?? [],
    );
    const deductionDetails = Object.fromEntries(
      item?.totalDeductionDetails?.map((d) => [d?.displayText, toNumber(d?.value)]) ?? [],
    );

    return {
      "Employee Number": isTotalRow ? "" : item?.employeeId,
      "Employee Name": isTotalRow ? "" : item?.employeeName,
      "Join Date": isTotalRow ? "" : item?.dateOfJoining ?? "",
      "Left Date": isTotalRow ? "" : item?.leftDate ?? "",
      Status: isTotalRow ? "Total" : item?.employeeStatus ?? "",
      "No. of Working Days": item?.daysInMonth ?? "",
      "LOP (Loss of Pay)": item?.lossOfPay ?? 0,
      "LOP Amount": item?.lopAmount ?? 0,
      "Basic Salary": grossDetails?.["BASIC SALARY"] ?? 0,
      "HRA (House Rent Allowance)": grossDetails?.["HRA (House Rent Allowance)"] ?? 0,
      "Special Allowance": grossDetails?.["SPECIAL ALLOWANCE"] ?? 0,
      "EPA (Employer Pension Account, if applicable)":
        grossDetails?.["EMPLOYEER PF"] ?? grossDetails?.["EMPLOYER PF"] ?? 0,
      "Gross Salary": item?.totalGrossPay ?? 0,
      "Professional Tax": deductionDetails?.["PROFESSIONAL TAX"] ?? 0,
      "Income Tax": deductionDetails?.["INCOME TAX"] ?? 0,
      "Employer PF Contribution":
        item?.employerPfContribution ??
        grossDetails?.["EMPLOYEER PF"] ??
        grossDetails?.["EMPLOYER PF"] ??
        0,
      "Employee PF Contribution":
        item?.employeePfContribution ??
        deductionDetails?.["EMPLOYEE PF"] ??
        deductionDetails?.["EMPLOYEE PF CONTRIBUTION"] ??
        deductionDetails?.["PF CONTRIBUTION"] ??
        deductionDetails?.["PF Contribution"] ??
        0,
      "Total Deductions": item?.totalDeduction ?? 0,
      "Net Pay": item?.totalNetPay ?? 0,
    };
  });
};
